import React, { useEffect, useState } from 'react';

function TrunksInboundDispatcher({ changeValues, defaultIpLocal = '' }) {
  const [provider, setProvider] = useState('');
  const [ipsMatchRaw, setIpsMatchRaw] = useState('');
  const [ipLocal, setIpLocal] = useState(defaultIpLocal);
  const [codec, setCodec] = useState('alaw,ulaw');
  const [providerError, setProviderError] = useState('');

  const PROVIDER_REGEX = /^[a-z0-9][a-z0-9_-]{2,63}$/;

  const buildCsv = (raw) => raw
    .split(/[\n,;\s]+/)
    .map((t) => t.trim())
    .filter((t) => t.length > 0)
    .map((t) => (t.includes('/') ? t : `${t}/32`))
    .join(',');

  useEffect(() => {
    const csv = buildCsv(ipsMatchRaw);
    const providerValid = PROVIDER_REGEX.test(provider);
    const hasIps = csv.length > 0;
    const hasLocal = ipLocal.trim().length > 0;
    changeValues({
      name: '__inboundDispatcherState',
      value: {
        provider,
        ipsMatch: csv,
        ipLocal: ipLocal.trim(),
        codec,
        valid: providerValid && hasIps && hasLocal,
      },
    });
    setProviderError(providerValid || provider === '' ? '' : 'Use apenas minúsculas, dígitos, "-" e "_" (3 a 64).');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provider, ipsMatchRaw, ipLocal, codec]);

  return (
    <div>
      <p className="form-section-title">Tronco Inbound Dispatcher (VGS)</p>
      <p className="form-help-text">
        Use este tipo apenas para troncos operados pela própria VIGOS que precisam
        receber chamadas de múltiplos IPs e distribuir para vários tenants
        (roteamento via DID). O contexto será fixado em <code>inbound-dispatcher</code>.
      </p>

      <div className="field">
        <label className="label" htmlFor="inboundd-provider">Identificador do tronco *</label>
        <input
          id="inboundd-provider"
          className="input"
          type="text"
          placeholder="ex.: tip-principal, xhand-2026"
          value={provider}
          onChange={(e) => setProvider(e.target.value.toLowerCase())}
          maxLength={64}
        />
        {providerError && <p className="form-error">{providerError}</p>}
      </div>

      <div className="field">
        <label className="label" htmlFor="inboundd-ips">IPs de origem (um por linha)</label>
        <textarea
          id="inboundd-ips"
          className="textarea"
          rows={6}
          placeholder={'216.10.29.131\n189.113.38.59\n186.209.52.0/24'}
          value={ipsMatchRaw}
          onChange={(e) => setIpsMatchRaw(e.target.value)}
        />
        <p className="form-help-text">
          Aceita IPv4 simples (será normalizado com <code>/32</code>) ou com prefixo CIDR.
          Vírgulas, ponto-e-vírgulas e espaços também são aceitos como separadores.
        </p>
      </div>

      <div className="field">
        <label className="label" htmlFor="inboundd-ip-local">IP local do PBX (from_domain) *</label>
        <input
          id="inboundd-ip-local"
          className="input"
          type="text"
          placeholder="ex.: 147.93.71.203"
          value={ipLocal}
          onChange={(e) => setIpLocal(e.target.value)}
        />
      </div>

      <div className="field">
        <label className="label" htmlFor="inboundd-codec">Codecs</label>
        <input
          id="inboundd-codec"
          className="input"
          type="text"
          value={codec}
          onChange={(e) => setCodec(e.target.value)}
        />
        <p className="form-help-text">Separe por vírgula (ex.: <code>alaw,ulaw,g729</code>). Permitidos: alaw, ulaw, g729, opus, g722, h264.</p>
      </div>
    </div>
  );
}

export default TrunksInboundDispatcher;
